import { faEye, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { deleteProductById, getCartDetailsById } from '../services/cart.services';
import notistack from 'modules/core/notistack';
import { Modal, Button } from 'react-bootstrap';
import DataGrid, { Column, Scrolling } from 'devextreme-react/data-grid';
import { useNavigate } from 'react-router-dom';

interface ActionButtonProp {
    selectedId: string | number;
    customerId: string | number;
    reloadDataSource: () => void;
}

const ActionButton: React.FC<ActionButtonProp> = ({ selectedId, reloadDataSource, customerId }) => {
    const [showProducts, setShowProducts] = useState(false);
    const [products, setProducts] = useState<any[]>([]);
    const [errMsg, setErrMsg] = useState<string>('');

    const [confirmDeleteId, setConfirmDeleteId] = useState<any>(null);
    const [showConfirm, setShowConfirm] = useState(false);

    const getAvailableProducts = async () => {
        try {
            const response: any = await getCartDetailsById(selectedId);
            if (response.status === 200) {
                setProducts(response.data);
                setErrMsg('');
                setShowProducts(true);
            } else if (response.status === 400) {
                setErrMsg(response?.message ?? '');
                setProducts(response.data || []);
                setShowProducts(true);
            }
        } catch (error: any) {
            notistack.error(error.message);
        }
    };

    const handleDeleteRow = async (id: any) => {
        try {
            const response: any = await deleteProductById(id, selectedId);
            if (response.status === 200) {
                setProducts(prev => prev.filter(item => item.id !== id));
                notistack.notifyFromApi(response);
                reloadDataSource()
                setErrMsg('');
            } else {
                notistack.notifyFromApi(response);
            }
        } catch (error: any) {
            notistack.error(error.message);
        } finally {
            setShowConfirm(false);
            setConfirmDeleteId(null);
        }
    };

    const navigate = useNavigate();

    const handleToSalesEntery = () => {
        navigate('/new-transaction-entry', { state: { cartId: selectedId, customerId: customerId } });
        window.history.replaceState({}, document.title);
    }

    return (
        <div>
            <button
                className="btn btn-sm action-btn"
                title="View Product"
                onClick={getAvailableProducts}
            >
                <FontAwesomeIcon icon={faEye} className="ml-2" />
            </button>

            <button className='btn btn-sm action-btn' title='Redirect To Sales Entry' onClick={handleToSalesEntery}>
                <FontAwesomeIcon icon={faPlus} className="ml-2 text-danger" />
            </button>

            <Modal
                size="lg"
                show={showProducts}
                onHide={() => {
                    setShowProducts(false);
                    setProducts([]);
                    setErrMsg('');
                }}
                backdrop="static"
                centered
            >
                <Modal.Header closeButton>
                    <div>
                        <Modal.Title>Products List</Modal.Title>
                        {errMsg && <h6 className="text-danger mt-2 mb-0">{errMsg}</h6>}
                    </div>
                </Modal.Header>

                <Modal.Body style={{ height: '65vh', overflowY: 'auto' }}>
                    <div style={{ height: '100%', width: '100%' }}>
                        <DataGrid
                            dataSource={products}
                            keyExpr="id"
                            showBorders={true}
                            columnAutoWidth={true}
                            showRowLines={true}
                            rowAlternationEnabled={true}
                            noDataText="No products available"
                        >
                            <Scrolling mode="standard" useNative scrollByContent scrollByThumb />
                            <Column
                                caption="Actions"
                                width={100}
                                cellRender={({ data }) => (
                                    <button
                                        className="btn btn-sm action-btn delete-btn"
                                        title="Delete"
                                        onClick={() => {
                                            setConfirmDeleteId(data.id);
                                            setShowConfirm(true);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                )}
                            />
                            <Column dataField="bagNo" caption="Bag No" width={200} />
                            <Column dataField="collectionName" caption="Collection Name" width={150} />
                            <Column dataField="styleNo" caption="Style No." width={120} />
                            <Column
                                dataField="subMrp"
                                caption="Sub MRP"
                                dataType="number"
                                format="#,##0.00"
                                width={100}
                            />
                            <Column
                                dataField="isSrp"
                                caption="Is SRP"
                                width={100}
                                cellRender={({ value }) => (value ? 'Yes' : 'No')}
                            />
                        </DataGrid>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                size="sm"
                show={showConfirm}
                onHide={() => {
                    setShowConfirm(false);
                    setConfirmDeleteId(null);
                }}
                centered
                backdrop="static"
            >
                <Modal.Body className="text-center">
                    <h5>Are you sure?</h5>
                    <p className="text-muted mb-4">You are about to delete this product.</p>
                    <div className="d-flex justify-content-center gap-2">
                        <button
                            className='btn add-btn'
                            onClick={() => setShowConfirm(false)}
                        >
                            Cancel
                        </button>
                        <button
                            className='btn submit-btn'
                            onClick={() => handleDeleteRow(confirmDeleteId)}
                        >
                            Yes, Delete
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default ActionButton;
